import React from "react";
// import Progress from "../Progress";
import "../ContentPages/style.css";
import SubmitButton from "../Buttons/SubmitButton";
import CancelButton from "../Buttons/CancelButton";
import BackButton from "../Buttons/BackButton";
import Check from "../../assets/images/Check.svg";

export const NZPassport = ({ handleNext, handleCancel, handleBack }) => {
  return (
    <>
      <div className="intro">
        {/* <Progress progress={40} /> */}
        <h1 className="intro-title-mi" lang="mi-NZ">
          Kōrero mai ko wai koe
        </h1>
        <hr />
        <h1 className="intro-title">Tell us who you are</h1>

        <div className="step-container">
          <h2 className="step-title mb-2">
            Do you have a New Zealand passport?
          </h2>
          <p className="mb-4">You can use an expired passport.</p>
        </div>
        <div className="step-button-container">
          <SubmitButton text={"Yes"} Icon={Check} onClick={handleNext} ariaLabel="Yes - enter Passport details" />
          <CancelButton text={"No"} onClick={handleCancel} ariaLabel="No - next question" />
          <BackButton text={"Back"} onClick={handleBack} />
        </div>
      </div>
    </>
  );
};

export default NZPassport;
